<template>
  <Transition name="fade">
    <div v-show="loadingStore.isLoading" 
         class="fixed top-0 left-0 right-0 h-1 bg-primary-500 dark:bg-primary-dark-500 z-50 loading-bar"
    />
  </Transition>
</template>

<script setup lang="ts">
import { useLoadingStore } from '@/stores/loading'

const loadingStore = useLoadingStore()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.loading-bar {
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--color-primary-500) 50%,
    transparent 100%
  );
  animation: loading-bar 1.5s ease-in-out infinite;
  background-size: 200% 100%;
}

@keyframes loading-bar {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style> 